module.exports = __webpack_public_path__ + "static/administracion-502b51ca8ab867624b00f9fdebc7323d.svg";